import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MENU_ITEMS, MenuItem } from '../../menu.config';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AfterViewInit } from '@angular/core';
import { MentorService } from '../../services/staff/mentor.service';
import { PageHeaderComponent } from "../page-header/page-header.component";

declare var bootstrap: any;

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, RouterModule, RouterLink, PageHeaderComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})


export class NavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  isLoggedIn = false;
  userDetails: string = '';
  menuItems: MenuItem[] = [];
  expandedMenus: { [label: string]: boolean } = {};
  private destroy$ = new Subject<void>();
  username$: Observable<string | null>;
  isSidebarCollapsed = false;
  user: string = '';
  userNameDetails: any[] = [];
  userId: number = 0;
  constructor(private router: Router, private authService: AuthService,
    private mentorService: MentorService
  ) {
    this.username$ = this.authService.username$;
    console.log("Navbar component loaded",this.username$);
  }

  ngOnInit() {
    const updateMenuAndUser = (decoded: any) => {
      if (decoded) {
        console.log("decode in navbar is:",decoded)
        if(!isNaN(Number(decoded.username))){
          this.userId = Number(decoded.username);
          console.log("type of username",typeof(decoded.username));
          this.mentorService.GetUserDetails(Number(decoded.username)).subscribe({
            next:(res)=>{
              console.log("user response is",res);
              this.userNameDetails = res
            },
            error: (err)=>{
              console.error("fetching error is",err);
            }
          });
        }
        else{
          console.log("Skipping user details API for role user:", decoded.username);
          this.userNameDetails = [];
        }
        const role = decoded.role || '';
        // Filter both parent & child menus
        this.menuItems = MENU_ITEMS
          .filter(item => item.roles.includes(role))
          .map(item => ({
            ...item,
            children: item.children?.filter(child => child.roles.includes(role)) || []
          }));
        this.userDetails = decoded.username;
        this.isLoggedIn = true;
      } else {
        this.menuItems = [];
        this.userDetails = '';
        this.isLoggedIn = false;
      }
    };

    if (this.authService.isLoggedIn()) {
      this.user = this.authService.getUserDetails().username;
      updateMenuAndUser(this.authService.getUserDetails());
      console.log("user is",this.user);
    }

    this.authService.username$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        if (user) {
          updateMenuAndUser(this.authService.getUserDetails());
        } else {
          updateMenuAndUser(null);
        }
      });
  }

  //  ngAfterViewInit() {
  //   const dropdown = new bootstrap.Dropdown(document.getElementById('userMenuButton'), {
  //     popperConfig: {
  //       strategy: 'fixed'
  //     }
  //   });
  // }

  ngAfterViewInit() {
  if (!localStorage.getItem('authToken')) return;

  const btn = document.getElementById('userMenuButton');
  if (!btn) return;

  new bootstrap.Dropdown(btn, {
    popperConfig: { strategy: 'fixed' }
  });
}

  
  toggleMenu(label: string) {
    this.expandedMenus[label] = !this.expandedMenus[label];
  }

  toggleSidebar() {
  document.body.classList.toggle('toggle-sidebar');
}


  logout() {
    this.authService.logout();
    window.dispatchEvent(new Event('storage'));
    this.router.navigate(['/login'])
    .then(() => {
      window.location.reload();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

 formatUserName(details: any): string {
  if (!details) return '';

  const prefix: string = details.prefix || '';
  const surName: string = details.surName || '';
  const name: string = details.name || '';

  const surInitial = surName ? surName.charAt(0).toUpperCase() + '.' : '';

  const nameParts: string[] = name.trim().split(' ').filter((x: string) => x);

  if (nameParts.length === 0) return surInitial;

  const initials = nameParts
    .slice(0, -1)
    .map((x: string) => x.charAt(0).toUpperCase() + '.')
    .join('');

  const lastWord = nameParts[nameParts.length - 1];
  const lastWordTitleCase =
  lastWord.charAt(0).toUpperCase() + lastWord.slice(1).toLowerCase();

  return `${prefix}. ${surInitial}${initials} ${lastWordTitleCase}`;
}

formatUserNameList(details: any): string{
  if(!details) return '';
  const prefix: string = details.prefix || '';
  const surName: string = details.surName || '';
  const name: string = details.name || '';

  const surInitial = surName.charAt(0).toUpperCase() + surName.slice(1).toLowerCase();

  const nameTitlecase = name.split(' ').map((n)=>(n.charAt(0).toUpperCase()+n.slice(1).toLowerCase())).join(' ') 



  return `${prefix} ${surInitial} ${nameTitlecase}`;
}

onImgError(event: any){
  event.target.src = 'assets/pics/vcelogo.svg'
}


//   toggleSidebar() {
//   this.isSidebarCollapsed = !this.isSidebarCollapsed;
// }


  // closeSidebar() {
  // const sidebarE1 = document.getElementById('sidebarMenu');
  // if (sidebarE1) {
  //   const offcanvas = Offcanvas.getInstance(sidebarE1) || new Offcanvas(sidebarE1);
  //   offcanvas.hide();
  // }
  // }

}


